import { FilterFieldOperatorData } from 'common/filter/interfaces'
import { FieldTypeOperator } from 'common/filter/models/AudienceFilter/constants'

export const UNKNOWN_OPERATOR: FilterFieldOperatorData = {
  value: FieldTypeOperator.UNKNOWN_OPERATOR,
  label: '?',
  display: '',
}

export const REMOVE_TIMEOUT = 250
